<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>AIC ONE - reset password</title>
</head>

<body class="login-home background-body">
  <div class="container auth-logo-card-spacing align-items-center d-flex">
    <!-- Left / Brand -->
    <div class="logo-section">
      <img :src="styleConfig.reset_logo" alt="aicone Logo" class="logo" />
      <div class="user-count d-none">
        <div class="user-dots d-flex">
          <div class="dot"></div><div class="dot"></div><div class="dot"></div>
        </div>
        <span>3k+ people joined us, now it's your turn</span>
      </div>
    </div>

    <!-- Right / Card -->
    <div class="sign-in-form">
      <!-- verifying -->
      <div v-if="verifying" class="mt-3 text-center">
        <i class="fas fa-spinner fa-spin me-2"></i> Verifying link…
      </div>

      <!-- invalid -->
      <div v-else-if="!link_valid" class="mt-3 text-center">
        <h2 class="text-black fw-bold mb-2">Invalid link</h2>
        <p class="text-muted small">Link is invalid or expired. Request a new one.</p>
        <router-link to="/reset" class="btn btn-outline-dark btn-sm mt-2">Request new link</router-link>
        <div class="forgot-password mt-4">
          <span>Back to <router-link class="text-danger" to="/">Login</router-link></span>
        </div>
      </div>

      <!-- valid -->
      <div v-else class="mt-3">
        <h2 class="text-black fw-bold">Set a new password</h2>
        <p class="text-black text-sm">
          Choose a strong password for <strong>{{ email || 'your account' }}</strong>.
        </p>

        <form @submit.prevent="submit_reset">
          <div class="form-floating-custom">
            <input :type="password_visible ? 'text' : 'password'"
              id="new_password"
              class="form-input"
              placeholder=" "
              v-model="new_password"
              autocomplete="new-password"
            />
            <label class="form-label" for="new_password">New password</label>
               <button type="button" class="password-toggle" @click="toggle_password_visibility('password')">
            <i :class="password_visible ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
          </button>
          </div>

          <div class="form-floating-custom">
            <input :type="confirm_password_visible ? 'text' : 'password'"
              id="confirm_password"
              class="form-input"
              placeholder=" "
              v-model="confirm_password"
              autocomplete="new-password"
            />
            <label class="form-label" for="confirm_password">Confirm password</label>
              <button type="button" class="password-toggle" @click="toggle_password_visibility('confirm')">
            <i :class="confirm_password_visible ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
          </button>
          </div>

          <div class="password-criteria mt-1 mb-2 text-start small">
          <div class="criteria-item">
            <i :class="{ 'fa fa-check-circle text-success': meets_criteria.length, 'fa fa-check-circle': !meets_criteria.length }"
              class="me-1"></i> At least 8 characters
          </div>
          <div class="criteria-item">
            <i :class="{ 'fa fa-check-circle text-success': meets_criteria.lowercase, 'fa fa-check-circle': !meets_criteria.lowercase }"
              class="me-1"></i> Lowercase letter
          </div>
          <div class="criteria-item">
            <i :class="{ 'fa fa-check-circle text-success': meets_criteria.uppercase, 'fa fa-check-circle': !meets_criteria.uppercase }"
              class="me-1"></i> Uppercase letter
          </div>
          <div class="criteria-item">
            <i :class="{ 'fa fa-check-circle text-success': meets_criteria.special, 'fa fa-check-circle': !meets_criteria.special }"
              class="me-1"></i> Special character
          </div>
        </div>

          <button
            type="submit"
            class="btn sign-up-btn btn-dark w-100 fw-bold mb-2"
            :disabled="submitting"
          >
            <span v-if="submitting"><i class="fas fa-spinner fa-spin me-2"></i> Saving…</span>
            <span v-else>Reset Password</span>
          </button>

          <div class="forgot-password mt-3 text-center">
            <span>Back to <router-link class="text-danger" to="/">Login</router-link></span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- Powered By Footer -->
  <div class="position-fixed bottom-0 start-50 translate-middle-x small text-white pb-3">
    © {{ current_year }} Powered by <span class="fw-bold">{{ powered_by_name }}</span>
  </div>
</body>
